<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready" :show-background="true" container-class="max-w-sm px-4 py-6">
            <div v-if="ready">
                <h1 class="mb-3 text-xl font-bold leading-tight text-center text-highlight-100">
                    {{ _('pack_title') }}
                </h1>

                <div v-if="displayRedeem">
                    <p class="mt-8 text-center text-highlight-100">
                    {{ _('pack_redeem_question') || 'Already have a pack?' }}
                    </p>

                    <BaseButton
                        @click.native="redeem()"
                        type="button"
                        class="py-2 mt-2 mb-4 font-medium normal-case"
                        :secondary="true">
                        {{ _('pack_redeem_button') || 'Redeem' }}
                    </BaseButton>
                </div>

                <BaseTabs
                    v-if="periods.length > 1"
                    :periods="periods"
                    :pre-selected="params.period_id"
                    @change="(period) => {this.period = period.label}"
                />

                <template v-for="pack in packs[periodOrFirst]">
                    <PlanCard
                        v-for="plan in pack.plans"
                        :key="plan.external_id"
                        :pack="pack"
                        :plan="plan"
                        class="mb-8"
                        @selected="select(plan.external_id, pack)"
                    />
                </template>

                <StickyFooter>
                    {{ _(`${this.provider.name.toLowerCase()}_pack_disclaimer_1`) }}
                    {{ _(`${this.provider.name.toLowerCase()}_pack_disclaimer_2`) }}
                    {{ _(`${this.provider.name.toLowerCase()}_pack_disclaimer_3`) }}
                </StickyFooter>
            </div>
        </Layout>
    </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'
import PlanCard from '@/components/Plan/PlanCard.vue'
import StickyFooter from '@/components/StickyFooter.vue'
import BaseTabs from '../components/Base/BaseTabs.vue'
import BaseButton from '../components/Base/BaseButton.vue'

export default {
    name: 'Pack',
    components: {
        BaseTabs,
        Layout,
        PlanCard,
        StickyFooter,
        BaseButton,
    },
    computed: {
        ...mapState({
            periods: (state) => state.packs.periods,
            packs: (state) => state.packs.grouped,
        }),
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            provider: 'providers/selected',
            params: 'settings/get',
            authenticated: 'user/authenticated',
            chargeStatus: 'charge/status',
        }),
        title() {
            return this.$router.currentRoute.name
        },
        periodOrFirst() {
            return this.period ?? this.periods[0].label
        },
        displayRedeem() {
            return process.env.VUE_APP_REDEEM === 'true' && this.provider.name === 'Safaricom'
        },
    },
    methods: {
        isAuthenticated() {
            return Object.keys(this.authenticated).length !== 0
        },
        isAndroid() {
            // eslint-disable-next-line camelcase
            return typeof AndroidCallbacks !== 'undefined'
        },
        isIos() {
            try {
                // eslint-disable-next-line no-undef
                return typeof webkit.messageHandlers.planPicked !== 'undefined'
            } catch (err) {
                return false
            }
        },
        deviceCallbackUserSelectedPack(pack) {
            if (this.isAndroid()) {
                // eslint-disable-next-line no-undef
                AndroidCallbacks.planPicked(pack)
            } else if (this.isIos()) {
                try {
                    // eslint-disable-next-line no-undef
                    webkit.messageHandlers.planPicked.postMessage(pack);
                } catch (err) {
                    console.log('Error accessing iOS message handlers')
                }
            }
        },
        select(id, pack) {
            this.$store.dispatch('packs/redeem', false)

            this.$store.dispatch('packs/select', id)
                .then(() => {
                    this.$store.dispatch('packs/setPack', pack)

                    if (this.isAuthenticated()) {
                        this.deviceCallbackUserSelectedPack(id)
                    }

                    this.$router.push({ name: 'Continue' })
                })
        },
        redeem() {
            this.$store.dispatch('packs/redeem', true)
                .then(() => {
                    this.$router.push({ name: 'Continue' })
                })
        },
    },
    created() {
        NProgress.start()

        // reset any complete/failed purchases
        if (this.chargeStatus !== 'PENDING') {
            this.$store.dispatch('packs/reset')
            this.$store.dispatch('charge/reset')
        }

        this.$store.dispatch('packs/fetch', {
            platform: this.params.platform,
            company_uuid: this.params.company_uuid,
            api_key: this.params.api_key,
            provider: this.provider.uuid,
            cc: this.params.cc,
            lang: this.params.lang,
        })
    },
    async mounted() {
        if (typeof this.provider === 'undefined') {
            this.$router.push('/')
        }
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
    },
    data() {
        return {
            showSecondPeriod: false,
            ready: false,
            period: null,
        }
    },
}
</script>
